module.exports = __webpack_public_path__ + "img/download-new-white.e192a96f.svg";